import React from 'react'
import { usePromiseTracker } from 'react-promise-tracker'
import { SmallLogo } from '../../../assets/images'

type Props = {
  loading?: boolean
}

const FullScreenLoader = (props: Props) => {
  const { loading } = props
  const { promiseInProgress } = usePromiseTracker()

  return (
    <React.Fragment>
      {promiseInProgress || loading ? (
        <div role="status" aria-live="polite" className="fixed inset-0 z-[1400] flex h-screen w-screen items-center justify-center bg-slate-500/25 backdrop-blur-[1px]">
          <img src={SmallLogo} alt="Loading" className="loader h-14 w-auto" />
        </div>
      ) : (
        ''
      )}
    </React.Fragment>
  )
}

export default FullScreenLoader
